import type { FC } from 'react';

import '@data/Simulations/pipeline/blocks/HideZeroValuesBlock';

type HideZeroValuesProps = {
    blockId: string;
};

const HideZeroValuesParameters: FC<HideZeroValuesProps> = () => null;

export default HideZeroValuesParameters;
